export default function getPaymentMethod(paymentMethods, gateway = 'stripe') {
  const methods = paymentMethods[gateway];

  if (methods?.multiple?.enabled === true) {
    return 'multiple';
  }

  return 'card';
}
